<template>
  <modal v-if="CustomPlaceOrder" v-model:show="showModal" :showClose="false" :clickClose="false">
    <template #header>
      <h5 class="modal-title">
        You are about to exit the positions for the users {{ currentUser?.name }}
      </h5>
    </template>
    <form id="my-form">
      <div>
        <label class="text-black text-xs font-weight-bold text-capitalize">Users:</label>
        <base-input name="selectmultiple" class="w-100 mr-2 mb-0">
          <el-select v-model="tempUserIds" multiple filterable :collapse-tags="shouldCollapseTags"
            placeholder="Select Users" @change="(val) => { handleSelectAll('user', val); usersFlag = false; }">
            <el-option :key="'select_all'" :label="getSelectAllLabel('user')" value="select_all" />
            <el-option v-for="option in sortedSelectOptions" :key="option.key" :label="option.value"
              :value="option.key" />
          </el-select>
          <small v-if="usersFlag" class="text-danger">User must be selected</small>
        </base-input>
      </div>
      <div class="mt-3">
        <label class="text-black text-xs font-weight-bold text-capitalize">Trading Symbols:</label>
        <base-input name="selectmultiple" class="w-100 mr-2 mb-0">
          <el-select v-model="tempInstruments" filterable :collapse-tags="shouldCollapseTagsInstruments"
            placeholder="Select Trading Symbols" @change="() => { tradingSymbolsFlag = false; }">
            <el-option v-for="option in sortedInstrumentsOptions" :key="option.key" :label="option.value"
              :value="option.value" />
          </el-select>
          <small v-if="tradingSymbolsFlag" class="text-danger">Trading symbol must be selected</small>
        </base-input>
      </div>
      <div class="row">
        <div class="col-sm-6 col-12 mt-3">
          <label class="text-black text-xs font-weight-bold text-capitalize">Exchange</label>
          <base-input class="w-100 mb-0">
            <el-select v-model="exchanges" placeholder="Select Exchange" clearable class="w-100"
              @change="() => { this.exchangesFlag = false; }">
              <el-option v-for="ex in exchangeOptions" :key="ex" :label="ex" :value="ex" />
            </el-select>
          </base-input>
          <small v-if="exchangesFlag" class="text-danger">Exchange must be selected</small>
        </div>
        <div class="col-sm-6 col-12 mt-3">
          <label class="text-black text-xs font-weight-bold text-capitalize">Trigger</label>
          <base-input class="w-100 mb-0">
            <el-select v-model="triggers" placeholder="Select Trigger" clearable class="w-100"
              @change="() => { this.triggersFlag = false; }">
              <el-option v-for="tg in triggerOptions" :key="tg" :label="tg" :value="tg" />
            </el-select>
          </base-input>
          <small v-if="triggersFlag" class="text-danger">Trigger must be selected</small>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6 col-12 mt-3">
          <label class="text-black text-xs font-weight-bold text-capitalize">TradeTerm:</label>
          <base-input name="selectmultiple" class="w-100 mr-2 mb-0">
            <el-select class="w-100" v-model="selectedTradeTerm" placeholder="Select TradeTerm" clearable
              @change="() => { this.tradeTermFlag = false; }">
              <el-option class="select-primary" v-for="item in tradeTerms" :key="item" :label="item" :value="item" />
            </el-select>
          </base-input>
          <small v-if="tradeTermFlag" class="text-danger">TradeTerm must be selected</small>
        </div>
        <div class="col-sm-6 col-12 mt-3">
          <label class="text-black text-xs font-weight-bold text-capitalize">Quantity:</label>
          <input type="number" v-model="placeOrderQuantity" @input="() => { this.placeOrderQuantityFlag = false; }"
            class="form-control" />
          <small v-if="placeOrderQuantityFlag" class="text-danger">
            {{ placeOrderQuantityMessage }}<br />
          </small>
        </div>
      </div>
    </form>
    <div class="mt-4 d-flex justify-content-end">
      <button type="button" class="btn btn-secondary" @click="closeModal()">Close</button>
      <button class="btn btn-primary" type="button" @click="customExit()">Custom PlaceOrder</button>
    </div>
    <div v-if="errorFlag" class="mt-3 d-flex justify-content-center">
      <small class="text-danger">{{ errorMessage }}</small>
    </div>
  </modal>
  <modal v-model:show="showVerifyModal" :showClose="false" :clickClose="false">
    <form>
      <div class="mb-3">
        <h1 class="display-1 mb-0 text-center text-primary">{{ randomNum }}</h1>
      </div>
      <div class="mb-3">
        <label for="user-input"
          class="text-black text-sm d-flex justify-content-center align-item-center font-weight-bold text-capitalize">
          please enter the provided number:
        </label>
        <input type="text" v-model="userInput" class="form-control d-flex justify-content-center align-item-center"
          id="user-input" maxlength="3" placeholder="Enter 3-digit number" />
      </div>
    </form>
    <div class="mt-4 d-flex justify-content-end">
      <button type="button" class="btn btn-secondary" @click="goToPrevious()">Edit</button>
      <button class="btn btn-primary" type="button" @click="validateInput()">Verify</button>
    </div>
    <div class="mt-3 d-flex justify-content-center">
      <small class="text-danger">{{ validationMessage }}</small>
    </div>
    <div v-if="errorFlag" class="mt-3 d-flex justify-content-center">
      <small class="text-danger">{{ errorMessage }}</small>
    </div>
  </modal>
</template>
<script>
import { ElSelect, ElOption, ElInput } from "element-plus";
import Modal from "@/components/Modal";
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";

export default {
  name: "CustomPlaceOrderModal",
  components: {
    Modal,
    [ElSelect.name]: ElSelect,
    [ElOption.name]: ElOption,
    [ElInput.name]: ElInput,
  },
  props: {
    showModal: { type: Boolean, default: false },
    CustomPlaceOrder: { type: Boolean, default: false },
    currentUser: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      errorFlag: false,
      errorMessage: "",
      tempUserIds: [],
      selectOptions: [],
      tempInstruments: [],
      instrumentOptions: [],
      tradeTerms: ["OVERNIGHT", "INTRADAY"],
      selectedTradeTerm: "",
      placeOrderQuantity: "",
      placeOrderQuantityFlag: false,
      placeOrderQuantityMessage: "Quantity is required",
      exchanges: "",
      triggers: "",
      exchangeOptions: [],
      triggerOptions: ["BUY", "SELL", "SHORT", "COVER"],
      exchangesFlag: false,
      triggersFlag: false,
      tradeTermFlag: false,
      usersFlag: false,
      tradingSymbolsFlag: false,
      showVerifyModal: false,
      randomNum: "",
      userInput: "",
      validationMessage: "",
    };
  },
  computed: {
    shouldCollapseTags() {
      const allUserIds = this.selectOptions.map((option) => option.key);
      return this.tempUserIds.length > 10 || this.tempUserIds.length === allUserIds.length;
    },
    sortedSelectOptions() {
      return [...this.selectOptions].sort((a, b) => {
        const isASelected = this.tempUserIds.includes(a.key);
        const isBSelected = this.tempUserIds.includes(b.key);
        if (isASelected === isBSelected) return a.value.localeCompare(b.value);
        return isASelected ? -1 : 1;
      });
    },
    shouldCollapseTagsInstruments() {
      const total = this.instrumentOptions.length;
      return this.tempInstruments.length > 10 || this.tempInstruments.length === total;
    },
    sortedInstrumentsOptions() {
      return [...this.instrumentOptions].sort((a, b) => {
        const isASelected = this.tempInstruments.includes(a.key);
        const isBSelected = this.tempInstruments.includes(b.key);
        if (isASelected === isBSelected) return a.value.localeCompare(b.value);
        return isASelected ? -1 : 1;
      });
    },
  },
  methods: {
    getSelectAllLabel(type) {
      if (type === "user") {
        const allUserIds = this.selectOptions.map((o) => o.key);
        return this.tempUserIds.length === allUserIds.length ? "Deselect All Users" : "Select All Users";
      }
    },
    handleSelectAll(type, value) {
      if (type !== "user") return;
      const selectAllKey = "select_all";
      const allKeys = this.selectOptions.map(o => o.key);
      if (Array.isArray(value) && value.includes(selectAllKey)) {
        if (this.tempUserIds.length === allKeys.length + 1) {
          this.tempUserIds = [];
        } else {
          this.tempUserIds = [...allKeys];
        }
      } else if (Array.isArray(this.tempUserIds) && this.tempUserIds.includes(selectAllKey)) {
        this.tempUserIds = this.tempUserIds.filter(v => v !== selectAllKey);
      }
      this.usersFlag = this.tempUserIds.length === 0;
    },
    closeModal() {
      this.errorFlag = false;
      this.errorMessage = "";
      this.tempUserIds = [];
      this.tempInstruments = [];
      this.selectedTradeTerm = "";
      this.placeOrderQuantity = "";
      this.placeOrderQuantityFlag = false;
      this.exchanges = "";
      this.triggers = "";
      this.exchangesFlag = false;
      this.triggersFlag = false;
      this.tradeTermFlag = false;
      this.usersFlag = false;
      this.tradingSymbolsFlag = false;
      this.$emit('updateParameters', false, false);
    },
    getRandomNumber() {
      this.randomNum = Math.floor(100 + Math.random() * 900);
    },
    customExit() {
      this.placeOrderQuantityFlag = !this.placeOrderQuantity || Number(this.placeOrderQuantity) <= 0;
      this.exchangesFlag = !this.exchanges;
      this.triggersFlag = !this.triggers;
      this.tradeTermFlag = !this.selectedTradeTerm;
      this.usersFlag = this.tempUserIds.length === 0;
      this.tradingSymbolsFlag = this.tempInstruments.length === 0;
      if (this.placeOrderQuantityFlag || this.exchangesFlag || this.triggersFlag || this.tradeTermFlag || this.usersFlag || this.tradingSymbolsFlag) {
        this.errorFlag = true;
        return;
      }
      this.errorFlag = false;
      this.errorMessage = "";
      this.$emit("updateParameters", false, this.CustomPlaceOrder);
      this.getRandomNumber();
      this.showVerifyModal = true;
    },
    goToPrevious() {
      this.showVerifyModal = false;
      this.$emit("updateParameters", true, this.CustomPlaceOrder);
    },
    validateInput() {
      if (parseInt(this.userInput) === this.randomNum) {
        this.validationMessage = "";
        this.endAllOrders();
      } else {
        this.errorFlag = false;
        this.validationMessage = "Incorrect number. Please try again.";
      }
    },
    async endAllOrders() {
      console.log("Executing custom exit order...");
      const data = {
        otp: "123",
        users: this.tempUserIds,
        tradingSymbol: this.tempInstruments,
        tradeTerm: this.selectedTradeTerm,
        quantity: Number(this.placeOrderQuantity),
        exchange: this.exchanges,
        trigger: this.triggers,
      };
      this.$store
        .dispatch("settingStore/customPlaceOrder", data, { root: true })
        .then(() => {
          this.showVerifyModal = false;
          swal.fire({
            title: "Custom Exit Order!",
            text: "Request to custom exit the positions are placed.",
            buttonsStyling: false,
            customClass: { confirmButton: "btn btn-success" },
            icon: "success",
          });
          this.closeModal();
        })
        .catch((error) => {
          this.errorFlag = true;
          this.errorMessage = error?.server?.response?.data?.message || error?.message || "Something went wrong";
        });
    },
    getActiveUsers() {
      const data = { type: "active-users" };
      const key = `${data.type}-reference-data`;
      const cached = sessionStorage.getItem(key);
      if (cached) {
        this.selectOptions = JSON.parse(cached);
      } else {
        this.$store
          .dispatch("commonStore/getReferenceData", data, { root: true })
          .then((response) => {
            this.selectOptions = response.server.data;
            sessionStorage.setItem(key, JSON.stringify(this.selectOptions));
          })
          .catch((error) => console.log(error));
      }
    },
    getActiveInstruments() {
      const data = { type: "active-instruments" };
      const key = `${data.type}-reference-data`;
      const cached = sessionStorage.getItem(key);
      if (cached) {
        this.instrumentOptions = JSON.parse(cached);
      } else {
        this.$store
          .dispatch("commonStore/getReferenceData", data, { root: true })
          .then((response) => {
            this.instrumentOptions = response.server.data;
            sessionStorage.setItem(key, JSON.stringify(this.instrumentOptions));
          })
          .catch((error) => console.log(error));
      }
    },
    getExchanges() {
      this.$store.dispatch("exchangeStore/getExchanges", null, { root: true })
        .then(response => {
          const exchanges = response?.server?.data || [];
          this.exchangeOptions = exchanges.map(item => item.name);
        })
        .catch(error => {
          console.log(error);
        });
    },
  },
  mounted() {
    this.getActiveUsers();
    this.getActiveInstruments();
    this.getExchanges();
  },
};
</script>
